import React from 'react';
import { Row, Col } from "react-bootstrap";
import { Link, useLocation } from '../../../util/router';

const SiteCreationNav = props => {

  const { siteAdmin, siteLicense, siteView } = props.permissions;
  const colLayout = siteAdmin ? 3 : siteLicense && !siteAdmin ? 4 : 6;

  const basepath = "/solar/administration";

  const location = useLocation();

  const navItems = [
    {
      permission: siteAdmin,
      path: `${basepath}/site-creation/manage-site/execution-table`,
      label: "EXECUTION TABLE"
    },
    {
      permission: siteLicense,
      path: `${basepath}/site-creation/manage-site/operating-table`,
      label: "OPERATING TABLE"
    },
    {
      permission: siteView,
      path: `${basepath}/site-creation/manage-site/construction-table`,
      label: "CONSTRUCTION TABLE"
    },
    {
      permission: siteView,
      path: `${basepath}/site-creation/manage-site/invoicing-info-table`,
      label: "INVOICING INFO TABLE"
    }
  ];

  // add inset box shadow to active nav item
  const navItemStyle = navItem => {
    const active = location.pathname.includes(navItem.path);
    return active ? { boxShadow: 'inset 0px 0px 20px #00000057' } : {};
  }

  const renderNavItem = navItem => navItem.permission && (
    <Col
      sm={colLayout}
      className="panel-body"
      style={{ textAlign: "center" }}
    >
      <Link
        to={navItem.path}
        className="btn btn-primary"
        style={{ width: "100%", marginBottom: "10px", ...navItemStyle(navItem) }}
      >{navItem.label}</Link>
    </Col>
  )

  return (
    <Row>
      {navItems.map(renderNavItem)}
    </Row>
  );
};

export default SiteCreationNav;